module.exports = __webpack_public_path__ + "static/media/pager.a117c0b1.svg";